if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
          const msgInput = document.getElementById('message');
          const quick_add = document.getElementById('product-quick-add');
        // 获取 msg 的值并去除前后空格
        if (msgInput) {
            const msg = msgInput.value.trim();
            const formItem = document.querySelector('.tw-form-item');

            if (!msg) {
                if (formItem) {
                    formItem.classList.add('is-error');
                }
                return;
            } else {
                if (formItem) {
                    formItem.classList.remove('is-error');
                }
            }
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
         if (msgInput) {
        quick_add.classList.add('loading');
        quick_add.querySelector('.loading__spinner').classList.remove('hidden');
    }
      const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];  /* 浏览器会自动为 formData 对象生成带有边界(boundary)的 multipart/form-data 类型*/

                const formData = new FormData(this.form);
                // formData.append('sections', this.getSectionsToRender().map((section)=>section.section).join());
                // formData.append('sections_url', window.location.pathname);
                // config.body = formData;
              // custon add cart
                   let form_Data = {
                          'items': [],
                          'sections': this.cart.getSectionsToRender().map((section) => section.id),
                          'sections_url': window.location.pathname
                      };
                const checkboxes = document.querySelectorAll('.accessory-widget-input');
                const selectedItems = Array.from(checkboxes).reduce((items, checkbox) => {
                if (checkbox.checked) {
                    const dataId = parseInt(checkbox.getAttribute('data-id'), 10);
                    let properties = {};
        const propertyString = checkbox.getAttribute('data-properties'); // 可能是 JSON 格式
        if (propertyString) {
            try {
                properties = JSON.parse(propertyString);
            } catch (e) {
                console.warn('Invalid JSON in data-properties:', propertyString);
            }
        }

        items.push({
            'id': dataId,
            'quantity': 1,
            'properties': properties // 添加 properties
        });
                }
          return items;
      }, []);
       let currentItem = {};
      formData.forEach((value, key) => {
    if (!currentItem) currentItem = {};

    // Check for specific fields: id, properties[Ship Date], and quantity
    if (key === 'id' || key === 'quantity' || (key.includes("properties[") && key.endsWith("]"))) {
        // For properties[Ship Date], handle it separately
        if (key.includes("properties") && value !== '') {
            const propertyName = key.match(/properties\[(.*?)\]/)[1];
            currentItem.properties = {
                ...currentItem.properties,
                [propertyName]: value
            };
        } else if (value !== '') { // Check if value is not empty for id and quantity
            currentItem[key] = value;
        }
    }
});

selectedItems.push({ ...currentItem });
              console.log(selectedItems,"hello");
      form_Data.items = selectedItems;
              // end

                // fetch(`${window['routes']['cart_add_url']}`, config)
               fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                  'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
          body: JSON.stringify(form_Data),
          credentials: 'same-origin',
                  }).then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            quick_add.classList.remove('loading');
            quick_add.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
